import { Avatar, Button, Flex, Heading, Image } from "@chakra-ui/react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";

import { SettingsModal } from "./modals/SettingsModal";
import { selectedScenariosAtom } from "../shared/state/atoms";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useAccount,
  useMsal,
} from "@azure/msal-react";
import { useCallback } from "react";

export function AppHeader() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const account = useAccount();

  const [, setSelectedScenarios] = useAtom(selectedScenariosAtom);

  const login = useCallback(
    async (path: string) => {
      await instance.loginRedirect();
      navigate(path);
    },
    [instance, navigate]
  );

  const logout = useCallback(
    async (path: string) => {
      await instance.logoutRedirect();
      navigate(path);
    },
    [instance, navigate]
  );

  return (
    <Flex
      alignItems="center"
      bg="brand.white.100"
      boxShadow="sm"
      color="brand.red.100"
      maxW="100%"
      p={3}
      w="100vw"
    >
      <Image
        cursor="pointer"
        h={8}
        id="logo-header"
        ml={4}
        onClick={() => {
          setSelectedScenarios([]);
          navigate("/");
        }}
        src="/logo.png"
      />
      <Heading as="h1" fontWeight="bold" ml={8} mr="auto" my={1} size="sm">
        Verduurzamingskompas
      </Heading>
      <Flex alignItems="center" gap={4} justifyItems="space-between" ml={4}>
        <AuthenticatedTemplate>
          {account && (
            <Avatar
              cursor="pointer"
              name={account.name ?? account.username}
              onClick={() => navigate("/profile")}
              size="sm"
            />
          )}
          <Button onClick={() => logout("/")}>Uitloggen</Button>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Button onClick={() => login("/")}>Inloggen</Button>
        </UnauthenticatedTemplate>
        <SettingsModal />
      </Flex>
    </Flex>
  );
}
